/**
 * Has the player interacted with the page yet?
 *
 * Browsers refuse to start an AudioContext before a user gesture, and Chrome
 * logs "The AudioContext was not allowed to start" every time one is created or
 * resumed too early: a hover cue, a lobby sound or a match engine primed on
 * page load. `navigator.userActivation.hasBeenActive` turns true on the first
 * click, tap or key press, before that event's handlers run. Until then the
 * audio code simply stays silent and makes no context.
 *
 * Where the API does not exist (older browsers, jsdom), this answers true, so
 * behaviour there is exactly what it was before.
 */
export function pageHasUserActivation(): boolean {
  const nav = (globalThis as { navigator?: { userActivation?: { hasBeenActive?: boolean } } }).navigator;
  const activation = nav?.userActivation;
  if (activation === undefined) return true;
  return activation.hasBeenActive === true;
}
